import { render, staticRenderFns } from "./PxAutocompleteResponsaveis.vue?vue&type=template&id=daaf4a74"
import script from "./PxAutocompleteResponsaveis.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteResponsaveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports